import { Interpolation, Theme } from "@emotion/react";
import { Chip, colors } from "goi_common";
import { SANGJO_REVIEW_DETAIL_TEXT } from "../../constants/reviewTags";
import { useReviewPageRouter } from "../../hooks/useReviewPageRouter";

interface TagChipProps {
  tag: string;
  colorType?: "highlight" | "normal";
}

export const ReviewTagChip = ({ tag, colorType = "normal" }: TagChipProps) => {
  const { tag: tagQueryParams } = useReviewPageRouter();

  const colorPalatte = {
    normal: {
      장례지도사: {
        color: colors.orange650,
        backgroundColor: colors.orange100,
      },
      상담: {
        color: colors.blue600,
        backgroundColor: colors.blue100,
      },
      정책: {
        color: colors.green500,
        backgroundColor: colors.green50,
      },
      상황: {
        color: colors.warmGray700,
        backgroundColor: colors.warmGray100,
      },
      기본값: {
        color: colors.warmGray100,
        backgroundColor: colors.gray800,
      },
    },
    highlight: {
      장례지도사: {
        color: colors.orange700,
        backgroundColor: colors.orange100,
      },
      상담: {
        color: colors.blue700,
        backgroundColor: colors.blue100,
      },
      정책: {
        color: colors.green500,
        backgroundColor: colors.green50,
      },
      상황: {
        color: colors.brown500,
        backgroundColor: colors.warmGray200,
      },
      기본값: {
        color: colors.warmGray100,
        backgroundColor: colors.gray800,
      },
    },
  };

  const showColor = colorPalatte[colorType];

  const goiSangjoReviewTags = {
    장례지도사: {
      text: SANGJO_REVIEW_DETAIL_TEXT.장례지도사,
      ...showColor.장례지도사,
    },
    상담: {
      text: SANGJO_REVIEW_DETAIL_TEXT.상담,
      ...showColor.상담,
    },
    정책: {
      text: SANGJO_REVIEW_DETAIL_TEXT.정책,
      ...showColor.정책,
    },
    상황: {
      text: SANGJO_REVIEW_DETAIL_TEXT.상황,
      ...showColor.상황,
    },
    기본값: {
      color: colors.warmGray100,
      backgroundColor: colors.gray800,
      text: "",
    },
  } as {
    [key: string]: {
      color: string;
      backgroundColor: string;
      text: string;
    };
  };

  const detail = goiSangjoReviewTags[tag] || goiSangjoReviewTags.기본값;
  const isActived = tagQueryParams === tag;

  const text = detail?.text ? `# ${detail.text}` : "";
  const backgroundColor = isActived ? detail.backgroundColor : "transparent";
  const css: Interpolation<Theme> = {
    ":hover": {
      cursor: "default",
    },
  };

  return detail.text ? (
    <Chip
      padding={colorType === "highlight" ? "4px 12px" : "0px 4px"}
      className="subtitle_14_sb"
      borderColor="none"
      background={backgroundColor}
      color={detail.color}
      text={text}
      css={css}
      onClick={() => {}}
    />
  ) : (
    <></>
  );
};
